import { render, staticRenderFns } from "./commbook.vue?vue&type=template&id=7299b940&scoped=true"
import script from "./commbook.vue?vue&type=script&lang=js"
export * from "./commbook.vue?vue&type=script&lang=js"
import style0 from "./commbook.vue?vue&type=style&index=0&id=7299b940&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7299b940",
  null
  
)

export default component.exports